<style>
.no-padding-modal .ivu-modal-body {
  padding: 0;
}
</style>

<template>
  <div class="mg-b-20">
    <div class="bd-b pd-b-5 pd-t-10 mg-b-10">
      <div class="d-flex align-items-center justify-content-between">
        <span class="mg-b-0 tx-14">Эрх олгох шалгалтын бүртгэл</span>
        <button
          class="text-white btn btn-xs btn-primary pd-y-2 pd-x-5 btn-uppercase mg-l-auto"
          @click="examPointModal = true"
        >
          дүн харах
        </button>
      </div>
    </div>
    <div class="p-xxs" v-for="(f, i) in fileDownloads" :key="i">
      <a
        role="button"
        style="color: #0168fa"
        @click="downloadAttachment(f.value)"
        >{{ f.name }}</a
      >
    </div>
    <ul class="list-unstyled mg-b-0 m-t-sm" v-if="list.length > 0">
      <template v-for="(row, i) in list">
        <li class="list-item" :key="i">
          <div class="media align-items-center">
            <div class="media-body">
              <p class="tx-medium mg-b-0">{{ row.task }}</p>
              <p class="tx-12 mg-b-0 tx-color-03">
                {{ row.d1 | moment("YYYY/MM/DD") }} -
                {{ row.dueDate | moment("YYYY/MM/DD") }}
              </p>
            </div>
          </div>
          <div class="text-right tx-rubik">
            <button
              @click="sendRequest(row)"
              class="btn btn-xs btn-uppercase btn-primary flex-fill tx-spacing-1"
            >
              хүсэлт илгээх
            </button>
          </div>
        </li>
      </template>
    </ul>
    <div class="card m-b-sm" v-if="invoices.length > 0">
      <div class="card-body pd-0">
        <ul class="list-group list-group-flush tx-13">
          <li
            role="button"
            @click="continueExamRegistration(inv, i)"
            :key="i"
            v-for="(inv, i) in invoices"
            class="list-group-item pd-0"
          >
            <div class="d-flex pd-10">
              <div class="avatar d-none d-sm-block">
                <span
                  class="avatar-initial rounded-circle"
                  :style="
                    `min-width: 40px; background-color: ${displayStatus(
                      inv,
                      1
                    )}`
                  "
                >
                  {{ i + 1 }}
                </span>
              </div>
              <div class="pd-sm-l-20">
                <p class="tx-medium mg-b-0">
                  {{ inv.thirdOrganizationTask.task }}
                </p>
                <small class="tx-12 tx-color-03 mg-b-0">{{
                  inv.createdDate | moment("YYYY/MM/DD")
                }}</small>
              </div>
              <div class="text-right mg-l-auto">
                <p class="tx-medium mg-b-0">
                  <template v-if="inv.isTender == false">
                    <a
                      v-if="
                        inv.budget > 0 &&
                          $store.state.user.userInfo.groupId != 6126
                      "
                      @click="$emit('on-show-payment', inv.id)"
                      class="tx-12 mg-b-0 tx-danger"
                      >{{ inv.budget | formatMoney(2, ".", ",") }}₮ төлөх</a
                    >
                  </template>
                  <template v-else>
                    <template
                      v-if="inv.thirdOrganizationTask.objectTypeId == 340"
                      >{{ inv.budget | formatMoney(2, ".", ",") }}₮</template
                    >
                    <p v-else class="tx-12 mg-b-0 tx-success">
                      {{ inv.budget | formatMoney(2, ".", ",") }}₮ төлсөн
                    </p>
                  </template>
                </p>
              </div>
            </div>
            <div class="bd-t d-flex bg-light pd-10 align-items-center">
              <exam-invoice-accept
                ref="btnLearnExamInvoiceAccept"
                :taskId="inv.id"
                :task="inv"
                btnTxt="хэвлэх"
                class="m-rxs"
              >
                <button
                  slot="btn"
                  @click.stop="showPrint(i)"
                  type="button"
                  class="btn btn-xs btn-primary m-r-md"
                >
                  <span>хэвлэх</span>
                </button>
              </exam-invoice-accept>
              <div class="mg-l-auto">
                Төлөв:
                <span :style="`color: ${displayStatus(inv, 1)}`">{{
                  displayStatus(inv, 0)
                }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-else class="alert alert-secondary">Цахим бүртгэл хоосон байна.</div>

    <b-modal
      :transition-names="[]"
      class="no-padding-modal"
      v-model="examPointModal"
      :mask-closable="true"
      title="Шалгалт"
      hide-footer
      size="lg"
    >
      <exam-point v-if="examPointModal"></exam-point>
    </b-modal>

    <b-modal
      :transition-names="[]"
      class="no-padding-modal"
      v-model="showModal"
      :mask-closable="false"
      title="Цахим бүртгэл"
      @on-ok="SubmitRequest"
      :ok-text="step == 1 ? 'Дараах' : 'Илгээх'"
      @on-cancel="hideModal"
      footer-hide
      width="50vw"
      size="xl"
      hide-footer
      scrollable
    >
      <div class="p-sm">
        <Steps :active="step - 1" size="small" simple>
          <Step title="Бүртгэл" icon="el-icon-edit"></Step>
          <Step title="Шалгалт" icon="el-icon-check"></Step>
          <Step title="Материал" icon="el-icon-upload"></Step>
          <Step
            title="Төлбөр - Баталгаажуулалт"
            icon="el-icon-bank-card"
          ></Step>
        </Steps>
      </div>
      <Divider>{{ task.task }}</Divider>
      <div class="text-center">{{ courseDetail.s2 }}</div>
      <div v-show="step == 2">
        <exam-point></exam-point>
        <Divider>Сонголтоо хийнэ үү</Divider>
        <table class="table w-full table-god table-bordered">
          <!-- дүн -->

          <thead style="font-size: 10px">
            <tr>
              <th style="width: 30px">-</th>
              <th>{{ task.s2 }}</th>
              <th style="width: 100px">Цаг</th>
              <th style="width: 100px">Үнэ</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-show="courseDetail.budget > 0"
              style="background: #F0F0F0; text-align: right;"
            >
              <td colspan="3">Сургалтын төлбөр</td>
              <td style="font-weight: 700">
                {{ courseDetail.budget | formatMoney(2, ",", ".") }}₮
              </td>
            </tr>
            <tr style="background: #F0F0F0">
              <td colspan="4" style="font-weight: bold">
                <span>2. Шалгалт</span>
              </td>
            </tr>
            <tr v-for="(l, i) in lessons" :key="i">
              <td>
                <Checkbox v-model="l.selcd"></Checkbox>
              </td>
              <td>{{ l.task }}</td>
              <td>{{ l.st1 }}</td>
              <td style="text-align: right">
                {{ l.budget | formatMoney(2, ",", ".") }}₮
              </td>
            </tr>
            <tr style="background: #F0F0F0; text-align: right;">
              <td colspan="3">Хичээлийн үнэ</td>
              <td style="font-weight: 700">
                {{
                  lessons
                    .filter((l) => l.selcd == true)
                    .reduce((sum, l) => sum + l.budget, 0)
                    | formatMoney(2, ",", ".")
                }}₮
              </td>
            </tr>
            <tr style="background: #F0F0F0; text-align: right;">
              <td colspan="3">Нийт үнэ</td>
              <td style="font-weight: 700">
                {{
                  (courseDetail.budget +
                    lessons
                      .filter((l) => l.selcd == true)
                      .reduce((sum, l) => sum + l.budget, 0))
                    | formatMoney(2, ",", ".")
                }}₮
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <Form
        v-show="step == 1"
        :model="submitModel"
        label-width="250"
        class="p-sm"
      >
        <FormItem v-if="ssList.length > 0" label="Судалгааны сэдэв">
          <Select @on-change="ssChanged" filterable clearable>
            <Option v-for="s in ssList" :value="s.id" :key="s.id">{{
              s.task
            }}</Option>
          </Select>
          <Input
            v-model="submitModel.taskEn"
            placeholder="Судалгааны сэдэв..."
          />
        </FormItem>

        <FormItem label="Ажлын газар">
          <Input
            autofocus
            v-model="submitModel.task"
            placeholder="Ажлын газар..."
          />
        </FormItem>
        <template v-if="$store.state.user.userInfo.groupId == 6126">
          <FormItem label="Та харьяаллаа сонгоно уу?">
            <loc-type-cascader
              :id="submitModel.locTypeId4"
              checkStrictly
              v-model="submitModel.locTypeId4"
              :getParentType="true"
              locTypekey="examRefProvince"
            />
            <!-- <RadioGroup v-model="profileModel.i1">
              <Radio :label="1">
                <span>Тийм</span>
              </Radio>
              <Radio :label="0">
                <span>Үгүй</span>
              </Radio>
            </RadioGroup> -->
            
          </FormItem>
        </template>
        <template v-if="$store.state.user.userInfo.groupId == 6126">
          <FormItem label="Мэргэшсэн нягтлан бодогч">
            <RadioGroup v-model="profileModel.i1">
              <Radio :label="1">
                <span>Тийм</span>
              </Radio>
              <Radio :label="0">
                <span>Үгүй</span>
              </Radio>
            </RadioGroup>
          </FormItem>
        </template>
        <template v-if="$store.state.user.userInfo.groupId == 9157">
          <FormItem label="ACCA">
            <RadioGroup v-model="profileModel.i4">
              <Radio :label="1">
                <span>Тийм</span>
              </Radio>
              <Radio :label="0">
                <span>Үгүй</span>
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="Татварын мэргэшсэн зөвлөх">
            <RadioGroup v-model="profileModel.i5">
              <Radio :label="1">
                <span>Тийм</span>
              </Radio>
              <Radio :label="0">
                <span>Үгүй</span>
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="Таны ажиллаж амьдарч буй байршил">
            <loc-type-cascader
              :id="submitModel.locTypeId4"
              v-model="submitModel.locTypeId4"
              :getParentType="true"
              locTypekey="sysRefProvince"
            />
          </FormItem>
        </template>
        <template v-if="$store.state.user.userInfo.groupId == 6126">
          <FormItem label="Татварын улсын байцаагч">
            <RadioGroup v-model="profileModel.i2">
              <Radio :label="1">
                <span>Тийм</span>
              </Radio>
              <Radio :label="0">
                <span>Үгүй</span>
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="Нягтлан бодогч">
            <RadioGroup v-model="profileModel.i3">
              <Radio :label="1">
                <span>Тийм</span>
              </Radio>
            </RadioGroup>
          </FormItem>
        </template>
        <FormItem label="Шалгалтын журамтай танилцана уу.">
          <a @click="readGeree" role="button">энд дарж</a>
        </FormItem>
        <FormItem
          v-if="$store.state.user.userInfo.groupId == 6126"
          label="Цахим шалгалтын түр горимтой танилцана уу."
        >
          <a @click="readTurGorim">энд дарж</a>
        </FormItem>
        <FormItem
          :label="
            $store.state.user.userInfo.groupId == 6126
              ? 'Шалгалтын журам болон цахим шалгалтын түр горимыг зөвшөөрч байна уу ?'
              : 'Шалгалтын журмыг зөвшөөрж байна уу ?'
          "
        >
          <Checkbox v-model="submitModel.isRepeat"></Checkbox>
        </FormItem>
      </Form>

      <div v-if="step == 3" class="p-sm">
        <Alert
          type="warning"
          show-icon
          title="Анхааруулга"
          :closable="false"
          description="Бүрдүүлэх материал олон хуудастай бол PDF файл болгоод оруулна уу"
        ></Alert>
        <loader
          :ref="'direct_corebox_' + b.id"
          :key="i"
          v-for="(b, i) in reqDetail.b.filter((x) => x.ot == 440)"
          @box-loaded="materialTasksLoaded"
          :box="b"
          :prms="{ boxChooser: false }"
          :boxId="b.id"
          :objectTypeId="b.ot"
          :index="i + 1"
          :parentTask="reqDetail"
          :onMountedInitDisabled="false"
          :fromDetail="false"
          :scrollDisabled="true"
          :hideExtraButton="true"
          :hideAddButton="true"
          :detailSettingProp="{
            boxSetting: {
              autoHeight: true,
              hideToolbar: true,
              listSetting: { height: 150 },
            },
          }"
          @on-attach="onAttach"
        />

        <div class="mg-t-20 mg-b-20">
          <h5>Сонгосон шалгалтууд</h5>
          <loader
            :ref="'direct_corebox_' + b.id"
            :key="i"
            v-for="(b, i) in reqDetail.b.filter((x) => x.ot == 342)"
            :box="b"
            :prms="{ boxChooser: false }"
            :boxId="b.id"
            :objectTypeId="b.ot"
            :index="i + 1"
            :parentTask="reqDetail"
            :onMountedInitDisabled="false"
            :fromDetail="false"
            :scrollDisabled="true"
            :hideExtraButton="true"
            :hideAddButton="true"
            :detailSettingProp="{
              boxSetting: {
                autoHeight: true,
                hideToolbar: true,
                listSetting: { height: 150 },
              },
            }"
          />
        </div>
      </div>
      <div v-if="step == 4" class="p-sm">
        <go-payment
          :key="gopymntKey"
          ref="gopymnt"
          :autoHeight="true"
          :invoiceId="reqDetail.id"
          :hideBackBtn="true"
          @on-payback="step = 3"
          @on-pay-success="
            reqDetail.id = 0;
            paymentVisible = false;
            init();
            initInvoices();
          "
        >
          <button
            @click.stop="materialStep()"
            class="btn btn-warning btn-block"
          >
            Буцах
          </button>
        </go-payment>
      </div>
      <template v-if="courseDetail.s1 != null">
        <Alert
          v-if="courseDetail.s1 != ''"
          title="Анхааруулга"
          type="warning"
          show-icon
          >{{ courseDetail.s1 }}</Alert
        >
      </template>

      <div class="pd-md">
        <Alert type="error" show-icon title="Санамж" :closable="false">
          <span class="ivu-alert-desc" v-if="step == 1"
            >Та дараах өгөгдлийг бөглөснөөр бүртгэлийн дугаар авах ба бүртгэлийн
            дахин давтагдашгүй дугаар нэг л удаа олгогддог, ахин авах боломжгүй
            тул өөрийн мэдээллээ үнэн зөв оруулна уу</span
          >
          <span class="ivu-alert-desc tx-16" v-else-if="step == 2"
            >Та дараах шалгалтуудаас өөрийн орох шалгалтаа сонгоно уу.
            <br />Таны сонгосон шалгалт бүртгэлд орон баталгаажсан тохиолдолд
            өөрчлөх (нэмэх,хасах) боломжгүй тул ТА СОНГОЛТОО ЗӨВ хийнэ үү.<br />
            Танд амжилт хүсье.</span
          >
          <span class="ivu-alert-desc" v-else-if="step == 3"
            >Та
            {{ $store.state.user.userInfo.groupId == 9157 ? "6" : "9" }}
            өгөгдөлд шалгалтын бүртгэлд хавсаргах материалаа оруулна уу.
            Материал дутуу тохиолдолд шалгалтад бүртгэх боломжгүй ба материалын
            үнэн зөв байдлыг шалгуулагч бүрэн хариуцна.</span
          >
        </Alert>
      </div>

      <div class="text-center pd-5 pd-t-20">
        <ButtonGroup v-if="step != 4">
          <Button
            @click="hideModal"
            v-if="step < 3 || step == 4"
            type="error"
            >{{ step == 1 ? "Болих" : "Буцах" }}</Button
          >
          <Button @click="showModal = false" v-if="step == 3" type="warning"
            >Хаах / дараа үргэлжлүүлэх /</Button
          >
          <Button @click="SubmitRequest" type="primary">{{
            step == 3 ? "Илгээх" : "Дараах"
          }}</Button>
        </ButtonGroup>
      </div>
    </b-modal>
    <b-modal
      v-model="modalGeree.show"
      hide-footer
      title="Файл"
      centered
      body-class="pd-0"
      size="xl"
      scrollable
    >
      <div class="modal-body pd-0">
        <file-preview
          :id="modalGeree.id"
          v-if="modalGeree.rdy"
          :force="true"
          :minusHeight="200"
        />
      </div>
    </b-modal>
  </div>
</template>
<script>
import { request } from "@/api/all";
import "element-ui/lib/theme-chalk/index.css";
import {
  Button,
  Steps,
  Step,
  Divider,
  Form,
  FormItem,
  Checkbox,
  ButtonGroup,
  Alert,
  Input,
  RadioGroup,
  Radio,
  Message,
} from "element-ui";

import { getConfigValueByKey } from "@/libs/util";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import loader from "@/components/box/loader/loader.vue";
const moment = require("moment");
export default {
  components: {
    Button,
    Steps,
    Step,
    Divider,
    Form,
    FormItem,
    Checkbox,
    ButtonGroup,
    Alert,
    Input,
    RadioGroup,
    Radio,
    Message,
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    examInvoiceAccept: () => ({
      component: import(
        "@/views/modules/lms/student/components/examInvoiceAccept"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 300,
      timeout: 20000,
    }),
    examPoint: () => ({
      component: import("@/views/modules/lms/student/components/examPoint"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 300,
      timeout: 20000,
    }),
    loader,
    goPayment: () => ({
      component: import("@/components/modules/payment"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  name: "futureCourseList",
  props: {
    mode: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      reqDetail: {},
      stepCur: 0,
      examPointModal: false,
      fileDownloads: [],
      gopymntKey: 1,
      payInvoiceId: 0,
      paymentVisible: false,
      trueData: true,
      list: [],
      showModal: false,
      task: {},
      lessons: [],
      courseDetail: {},
      step: 1,
      stepPost: 2,
      submitModel: {},
      profileModel: {},
      ssList: [],

      invoices: [],
      materialFull: false,
      modalGeree: {
        show: false,
        rdy: false,
        id: 0,
      },
    };
  },
  mounted() {
    this.init();
    this.initFiles();
    this.initInvoices();
  },
  methods: {
    downloadAttachment(e) {
      request({
        api: { method: "get", url: "Media/FileInheritedDetail" },
        params: { id: e },
        store: this.$store,
      }).then((res) => {
        window.open(res.data.file.link);
      });
    },
    materialStep() {
      this.step = 3;
    },
    materialTasksLoaded(e) {
      e = e.tasks;
      if (this.$store.state.user.userInfo.groupId == 6126) {
        let allHaveAttachesCount = e.filter(
          (x) => x.defaultAttachmentId != null
        ).length;
        let allMaterialsCount = e.length;

        if (this.profileModel.i1 == 1) {
          if (allHaveAttachesCount == allMaterialsCount)
            this.materialFull = true;
          else this.materialFull = false;
        } else {
          let notMmnbiAll = e.filter((x) => x.taskEn != "mmnbi").length;
          let notMmnbiAttachesCount = e.filter(
            (x) => x.taskEn != "mmnbi" && x.defaultAttachmentId != null
          ).length;
          if (notMmnbiAttachesCount == notMmnbiAll) {
            this.materialFull = true;
          } else {
            this.materialFull = false;
          }
        }
      } else if (this.$store.state.user.userInfo.groupId == 9157) {
        this.materialFull = true;
      } else {
        let allHaveAttachesCount = e.filter(
          (x) => x.defaultAttachmentId != null
        ).length;
        let allMaterialsCount = e.length;
        if (allHaveAttachesCount == allMaterialsCount) this.materialFull = true;
      }
    },
    initInvoices() {
      request({
        api: { url: "Payment/GetMyInvoices", method: "get" },
        store: this.$store,
      }).then((res) => {
        this.invoices = res.data.tasks.filter(
          (x) =>
            x.thirdOrganizationTask != null &&
            x.thirdOrganizationTask.objectTypeId == 340
        );
      });
    },
    initFiles() {
      this.fileDownloads = this.$store.state.app.groupSettings.filter((x) =>
        x.key.includes("file_exam")
      );
    },
    fromInvoice(e) {
      this.invoices = e;
    },
    showPrint(i) {
      this.$refs.btnLearnExamInvoiceAccept[i].init();
    },
    reInit() {
      this.init();
    },
    ssChanged(e) {
      this.submitModel.taskEn = this.ssList.filter((f) => f.id == e)[0].task;
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      let _flag1 = -1;
      if (this.$store.state.user.userInfo.locType4Code == "member") {
        _flag1 = 2;
      } else if (this.$store.state.user.userInfo.locType4Code == "register") {
        _flag1 = 3;
      } else if (this.$store.state.user.userInfo.locType4Code == "learning") {
        _flag1 = 5;
      }
      switch (_flag1) {
        case 3:
        case 5:
          request({
            api: {
              url: "learn/GetFutureOnlineExamRegisterList",
              method: "get",
            },
            params: {
              flag1: _flag1,
            },
            store: this.$store,
          }).then((res) => {
            this.list = res.data.tasks;
          });
          break;
        default:
          break;
      }
    },
    payInvoice() {
      this.$refs.gopymnt.doPayment(this.reqDetail.id);
    },
    sendRequest(task) {
      if (task.id == 915570) {
        this.$Notice.info({
          title: "Мэдэгдэл",
          desc: "Шалгалтын бүртгэл хаагдсан.",
          duration: 60,
        });
      } else if (task.id == 915364) {
        this.$Notice.info({
          title: "Мэдэгдэл",
          desc:
            "Шалгалтын бүртгэл 2020-06-12 ны өдрийн 12:00 цагт бүртгэл хаагдав.",
          duration: 60,
        });
      } else {
        this.step = 1;
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: {
            url: "task/taskInheritedDetail",
            method: "get",
          },
          params: { id: task.id, requestFlag: 293 },
          store: this.$store,
        }).then((res) => {
          this.task = task;
          this.courseDetail = res.data.task;
          let invoiceBoxId = 0;
          if (this.courseDetail.b.filter((x) => x.ot == 343).length > 0) {
            invoiceBoxId = this.courseDetail.b.filter((x) => x.ot == 343)[0].id;
          }

          let _projid = 0;
          if (
            this.$store.state.app.groupDefaultProjects.filter(
              (x) => x.objectTypeId == 343
            ).length > 0
          ) {
            _projid = this.$store.state.app.groupDefaultProjects.filter(
              (x) => x.objectTypeId == 343
            )[0].id;
          }
          request({
            api: {
              url: "task/GetInherited",
              method: "get",
            },
            params: {
              id: 0,
              projectId: _projid,
              parentId: 0,
              boxId: invoiceBoxId,
              objectTypeId: 343,
              userId: this.$store.state.user.userId,
            },
            store: this.$store,
          }).then((res) => {
            if (res != false) {
              this.submitModel = res.data.task;
              request({
                api: {
                  url: "task/GetInherited",
                  method: "get",
                },
                params: {
                  id: this.$store.state.user.userInfo.profileId,
                },
                store: this.$store,
              }).then((resProfile) => {
                if (resProfile != false) {
                  this.profileModel = resProfile.data.task;
                  this.profileModel.i3 = 1;
                  this.submitModel.taskDesc =
                    this.courseDetail.task +
                    " төлбөр. Овог: " +
                    this.profileModel.lat +
                    " Нэр: " +
                    this.profileModel.task +
                    " Регистр: " +
                    this.profileModel.langCode;
                }
              });

              this.toggleBodyClass("removeClass", "dynamic-locker");

              this.submitModel.taskEn = "";
              this.submitModel.task = "";
              this.submitModel.thirdOrganizationTaskId = task.id;

              if (this.submitModel.isTender == null)
                this.submitModel.isTender = false;
              if (this.submitModel.isRepeat == null)
                this.submitModel.isRepeat = false;
              request({
                api: {
                  url: "task/boxInTaskList",
                  method: "get",
                },
                params: {
                  id: this.courseDetail.b.filter((x) => x.ot == 341)[0].id,
                  page: 0,
                  size: 100,
                },
                store: this.$store,
              }).then((res) => {
                this.lessons = res.data.tasks.filter((x) => x.isTender);
                this.showModal = true;
              });
            }
          });
        });
      }
    },
    hideModal() {
      if (this.step == 1) {
        this.task = {};
        this.showModal = false;
      }
      this.step--;
    },
    SubmitRequest() {
      let lids = this.lessons
        .filter((l) => l.selcd == true && l.locTypeCode == "chosen")
        .map(function(e) {
          return e.id;
        });

      let lidsSend = this.lessons
        .filter((l) => l.selcd == true)
        .map(function(e) {
          return e.id;
        });

      let errs = [];

      if (
        (this.$store.state.user.userInfo.groupId == 6126 ||
          this.$store.state.user.userInfo.groupId == 9157) &&
        this.step == 2
      ) {
        if (lidsSend.length == 0) {
          errs.push("Шалгалт сонгоогүй байна");
        }
      }

      if (this.submitModel.task == "" && this.step == 1) {
        errs.push("Ажлын газар оруулна уу !");
      }

      if (!this.submitModel.isRepeat && this.step == 1) {
        errs.push("Гэрээг зөвшөөрөөгүй байна !");
      }

      if (this.$store.state.user.userInfo.groupId == 6126 && this.step == 1) {
        if (this.submitModel.locTypeId4 <= 0) {
          errs.push("Та харьяаллаа сонгоно уу");
        }
      }

      if (this.$store.state.user.userInfo.groupId == 9157 && this.step == 1) {
        if (this.submitModel.locTypeId4 <= 0) {
          errs.push("Таны ажиллаж амьдарч буй байршил");
        }
      }

      if (this.step == this.stepPost) {
        var biPostoljChadahuu = false;
        if (this.ssList.length > 0) {
          if (this.submitModel.taskEn.length > 0) {
            biPostoljChadahuu = true;
          } else {
            biPostoljChadahuu = false;
          }
        } else {
          biPostoljChadahuu = true;
        }

        if (errs.length == 0) {
          if (biPostoljChadahuu) {
            this.toggleBodyClass("addClass", "dynamic-locker");
            if (this.submitModel.isRepeat) {
              if (this.submitModel.task == "") {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                Message.error("Ажлын газар оруулна уу.");
              } else {
                this.toggleBodyClass("addClass", "dynamic-locker");
                request({
                  api: { url: "Task/PostInherited", method: "post" },
                  data: { model: this.profileModel },
                  store: this.$store,
                });

                this.submitModel.parentId = 0;
                request({
                  api: { url: "Task/PostInherited", method: "post" },
                  data: { model: this.submitModel },
                  store: this.$store,
                }).then((resInv) => {
                  if (resInv.result == 1) {
                    this.toggleBodyClass("removeClass", "dynamic-locker");
                    console.log("beforeeeee task share", this.task.id);
                    request({
                      api: {
                        url: "TaskInUser/shareUserToTask",
                        method: "post",
                      },
                      data: {
                        taskId: this.task.id,
                        userId: this.$store.state.user.userId,
                      },
                      store: this.$store,
                    });

                    this.task = {};
                    this.toggleBodyClass("addClass", "dynamic-locker");
                    request({
                      api: {
                        url: "Payment/PostProductAndWorkservice",
                        method: "post",
                      },
                      data: { invoiceId: resInv.taskId, workIds: lidsSend },
                      store: this.$store,
                    }).then((resWork) => {
                      this.toggleBodyClass("removeClass", "dynamic-locker");
                      if (resWork != false) {
                        if (resWork.data.result == 1) {
                          this.continueExamRegistration({ id: resInv.taskId });

                          this.$emit("on-inf-fetch");
                          this.init();
                        } else if (resWork.data.result == 0) {
                          this.init();
                        } else {
                          this.$Notice.error({
                            title: "Алдаа",
                            desc:
                              "Байгууллага хариуцсан мэргэжилтэнд хандана уу. ",
                            duration: 60,
                          });
                        }

                        this.initInvoices();
                        this.$emit("reload-exam-registration");
                      }
                    });
                  } else {
                    this.toggleBodyClass("removeClass", "dynamic-locker");
                  }
                });
              }
            } else {
              this.toggleBodyClass("removeClass", "dynamic-locker");
              Message.error("Гэрээг зөвшөөрөөгүй байна !");
            }
          } else {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            Message.error("Судалгааны сэдэв бичнэ үү !");
          }
        } else {
          Message.error(errs[0]);
        }
      } else {
        if (
          this.lessons.filter((l) => l.locTypeCode == "chosen").length > 0 &&
          this.lessons.filter((l) => l.locTypeCode == "chosen").length < 5
        ) {
          if (lids.length == 0 && this.step == 1) {
            Message.error("Хичээл сонгоогүй байна !");
          } else {
            this.step++;
          }
        } else if (
          this.lessons.filter((l) => l.locTypeCode == "chosen").length >= 5
        ) {
          if (lids.length < 2 && this.step == 1) {
            Message.error(
              "Та тасралтгүй боловсрол олгох хичээлээс 2-оос доошгүй кредит цагийн хичээл судалсан байна"
            );
          } else {
            this.step++;
          }
        } else if (errs.length > 0) {
          Message.error(errs[0]);
        } else {
          if (this.step == 3) {
            if (this.materialFull) {
              this.updateExamInvoice();
            } else {
              Message.error("Бүрдүүлэх материал дутуу байна");
            }
          } else {
            this.step++;
          }
        }
      }
    },
    cascaderOnChange(value, selectedData) {},
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    onAttach(e) {
      this.modalGeree.show = true;
      this.modalGeree.id = e;
      this.modalGeree.rdy = true;
    },
    readGeree() {
      let _id = this.getConfigValueByKey("learnCourseAgreement");
      if (
        this.$store.state.user.userInfo.groupId == 9157 ||
        this.$store.state.user.userInfo.groupId == 6126 ||
        this.$store.state.user.userInfo.groupId == 1104
      ) {
        _id = this.getConfigValueByKey("learnExamAgreement");
      }
      this.modalGeree.show = true;
      this.modalGeree.id = parseInt(_id, 10);
      this.modalGeree.rdy = true;
    },
    readTurGorim() {
      this.modalGeree.show = true;
      this.modalGeree.id = 525871;
      this.modalGeree.rdy = true;
    },

    paymntCancel(e) {
      if (!e) {
        this.payInvoiceId = 0;
        this.paymentVisible = false;
        this.$refs.gopymnt.paymentCheckCount = 100;
      }
    },
    continueExamRegistration(inv, i) {
      if (inv.thirdOrganizationTask != undefined) {
        request({
          api: { url: "TaskInUser/GetSharedUserInfo", method: "get" },
          params: {
            trackUserId: this.$store.state.user.userId,
            taskId: inv.thirdOrganizationTask.id,
          },
          store: this.$store,
        }).then((res) => {
          if (res.data.user.colorCls != null && res.data.user.colorCls != "") {
            this.showPrint(i);
            Message.info("Таны мэдээлэл баталгаажсан байна.");
          } else {
            this.continueExamRegistrationAfter(inv);
          }
        });
      } else {
        this.continueExamRegistrationAfter(inv, 1);
      }
    },
    continueExamRegistrationAfter(inv, direct) {
      console.log(inv);
      request({
        api: { method: "GET", url: "servertime" },
        store: this.$store,
      }).then((res) => {
        if (
          direct == 1 ||
          moment(res.data.now).isBefore(inv.thirdOrganizationTask.dueStartDate)
        ) {
          request({
            api: {
              url: "task/GetInherited",
              method: "get",
            },
            params: {
              id: this.$store.state.user.userInfo.profileId,
            },
            store: this.$store,
          }).then((resProfile) => {
            if (resProfile != false) {
              this.profileModel = resProfile.data.task;
            }
          });
          request({
            api: {
              url: "task/taskInheritedDetail",
              method: "get",
            },
            params: {
              id: inv.id,
            },
            store: this.$store,
          }).then((res) => {
            if (res != false) {
              this.reqDetail = res.data.task;
              this.step = 3;
              this.showModal = true;
            }
          });
        } else {
          Message.info("Бүртгэл хаагдсан байна.");
        }
      });
      console.log(inv);
    },
    updateExamInvoice() {
      request({
        api: {
          url: "task/GetInherited",
          method: "get",
        },
        params: {
          id: this.reqDetail.id,
        },
        store: this.$store,
      }).then((res) => {
        var _model = res.data.task;
        _model["i7"] = 1;
        request({
          api: { url: "Task/PostInherited", method: "post" },
          data: { model: _model },
          store: this.$store,
        }).then((res) => {
          if (res.result == 1) {
            this.step++;
            this.initInvoices();
          }
        });
      });
    },
    displayStatus(inv, mode) {
      let rv = "";
      if (mode == 0) {
        if (inv.i8 == 1) {
          rv = "Баталгаажсан";
        } else if (inv.i7 != 1) {
          rv = "Материал дутуу";
        } else if (inv.i7 == 1 && !inv.isTender) {
          rv = "Төлбөр төлөгдөөгүй";
        } else {
          rv = "Хүлээгдэж буй";
        }
      } else if (mode == 1) {
        if (inv.i8 == 1) {
          rv = "#10b759";
        } else if (inv.i7 != 1) {
          rv = "#dc3545";
        } else if (inv.i7 == 1 && !inv.isTender) {
          rv = "#ffc107";
        } else {
          rv = "#00b8d4";
        }
      }
      return rv;
    },
  },
};
</script>
